/* eslint-disable max-len */
// @flow
import { connect } from 'react-redux';

import { fetchRencontre } from 'actions/rencontreActions';
import CompetitionsInternationalesSingleMatch from 'components/competitionsInternationales/CompetitionsInternationalesSingleMatch';
import type { DispatchType, StateType } from 'types/Actions';
import type {
  DispatchProps,
  StateProps
} from 'components/competitionsInternationales/CompetitionsInternationalesSingleMatch';

const mapStateToProps = (state: StateType): StateProps => ({
  rencontre: state.rencontreState.rencontre,
  status: state.rencontreState.status
});

const mapDispatchToProps = (dispatch: DispatchType): DispatchProps => ({
  fetchRencontre: (slug: string) => dispatch(fetchRencontre(slug))
});

export default connect(mapStateToProps, mapDispatchToProps)(CompetitionsInternationalesSingleMatch);
